export default __webpack_public_path__ + "images/SMM.e20270e.png";